// Package imports:
import React from 'react';
import { useNavigate } from 'react-router-dom';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate, formatNumber } from '../../services/utils';
// Type imports:
import { PublicTradeTickData } from '../../types/api/PublicTypes';

interface IOwnProps {
    trades: PublicTradeTickData[];
    buyer: string | null;
    seller: string | null;
    currentTradeId: string;
    symbol: string;
    date: string;
}

const RelatedTrades: React.FC<IOwnProps> = ({ trades, buyer, seller, currentTradeId, symbol, date }) => {
    const navigate = useNavigate();

    const handleRowClick = (trade: PublicTradeTickData) => {
        if (trade.trade_id === null) return;
        navigate(`/trade/${symbol}/${trade.trade_id}?date=${date}`);
    };

    return (
        <div id='RelatedTrades'>
            <h5 className='SectionTitle'>
                Other Trades by Same Participants
                {trades.length > 0 && <span className='TradeCount'> ({trades.length})</span>}
            </h5>
            <Table className='CompressedTable'>
                <thead>
                    <tr>
                        <th scope='col'>Time</th>
                        <th scope='col'>Buyer</th>
                        <th scope='col'>Aggressor</th>
                        <th scope='col'>Seller</th>
                        <th scope='col'>Price</th>
                        <th scope='col'>Volume</th>
                        <th scope='col'>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {trades.length === 0 ? (
                        <tr className='NoClick'>
                            <td className='text-left EmptyTableText' colSpan={7}>
                                No other trades by these participants on this day.
                            </td>
                        </tr>
                    ) : (
                        trades.map((trade, i) => {
                            const isCurrent = trade.trade_id !== null && String(trade.trade_id) === currentTradeId;
                            const buyerMatch = buyer && trade.trade_buyer === buyer;
                            const sellerMatch = seller && trade.trade_seller === seller;
                            return (
                                <tr
                                    key={trade.trade_id ?? i}
                                    className={
                                        (isCurrent ? 'current' : 'clickable') +
                                        (trade.trade_cancel !== 'N' ? ' cancelled' : '')
                                    }
                                    onClick={() => handleRowClick(trade)}
                                >
                                    <td>{formatDate(trade.timestamp, true, true)}</td>
                                    <td className={buyerMatch ? 'highlight-member' : undefined}>{trade.trade_buyer}</td>
                                    <td>
                                        {trade.aggressive_party === 'S' ? '<' : trade.aggressive_party === 'B' ? '>' : null}
                                    </td>
                                    <td className={sellerMatch ? 'highlight-member' : undefined}>{trade.trade_seller}</td>
                                    <td>{formatNumber(trade.price)}</td>
                                    <td>{formatNumber(trade.volume, 'volume')}</td>
                                    <td>{formatNumber(trade.value, 'volume')}</td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default RelatedTrades;
